module.exports = __webpack_public_path__ + "img/deleteWithStylePurple.90a65580.svg";